<script>
  import { intcomma } from 'journalize';

  // computed values
  const getPosNeg = (d) => {
    if (d.includes('-')) {
      return `+${Math.abs(d)} R`;
    } else {
      return `+${d} D`;
    }
  };
  // jenks breaks = [0.23, 0.29, 0.45, 0.57, 0.68, 0.86]
  const getDemColor = (value) => {
    if (value >= .68) {
      return '#306998';
    }
    else if (value > .57) {
        return '#5788b8';
      }
    else if (value > .45) {
      return '#83aed1';
    }
    else if (value > .29) {
      return '#c5dded';
    }
    else if (value >= .22) {
      return '#d9eaf5';
    }
  }

  const getDemColorText = (value) => {
    if (value >= .58) {
      return '#FFFFFF';
    }
    else {
      return '#000000';
    }
  }

  export let data;

  data = data
    .sort((a, b) => {
      return a.d_change - b.d_change;
    })
    .reverse();

  // Table row limit
  const limit = 10;
  let showAll = false;

  // flip the toggle on each click
  function onToggle() {
    showAll = !showAll;
  }
</script>

<table class="dg-table">
  <caption class='chart-head-vote'>Votes for <span class="democratic">Democratic</span> candidates by county</caption>
  <thead>
    <tr>
      <th scope="col" class="text-left">County</th>
      <th scope="col" class="text-right">2002</th>
      <th scope="col" class="text-right">2018</th>
      <th scope="col" class="text-right">Change</th>
    </tr>
  </thead>
  <tbody>
    {#each data as obj, idx}
      <tr class:display-none={idx + 1 > limit && !showAll}>
        <th scope="row" data-fips={obj.fips} class="text-left">
          {obj.county}
        </th>
        <td style="width:10%; background-color:{getDemColor(obj.d_pct_02)}; color:{getDemColorText(obj.d_pct_02)}" class="text-right">
          {((obj.d_pct_02) * 100).toFixed(0)}%
        </td>
        <td style="width:10%; background-color:{getDemColor(obj.d_pct_18)}; color:{getDemColorText(obj.d_pct_18)}" class="text-right">
          {((obj.d_pct_18) * 100).toFixed(0)}%
        </td>
        <td style="width:10%;" class="text-right {obj.d_change < 0 ? 'negative' : 'positive'}">
            {getPosNeg(intcomma((obj.d_change*100).toFixed(0))) || '-'}</td>
      </tr>
    {/each}
  </tbody>
</table>
<div class="text-center">
  <button class="btn" on:click={onToggle}>
    {showAll ? 'Show less' : 'Show all'}
  </button>
</div>

